import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import { MenuItem } from "@mui/material";
import { forwardRef } from "react";
import { useRefresh } from "react-admin";

interface LogoutButtonJwtProps {
  onClick?: () => void;
}

export const LogoutButtonJwt = forwardRef<HTMLLIElement, LogoutButtonJwtProps>(
  (props, ref) => {
    const refresh = useRefresh();

    const handleClick = async () => {
      localStorage.removeItem("jwttoken");
      localStorage.removeItem("codeVerifier");
      localStorage.removeItem("location");
      refresh();
    };

    return (
      <MenuItem onClick={handleClick} ref={ref}>
        <DashboardOutlinedIcon /> Logout
      </MenuItem>
    );
  }
);
